"use client";

import { cn } from "@oreme/ui";
import { cva, type VariantProps } from "class-variance-authority";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { ThemeBadge } from "@/components";
import type { ThemeTypeEnum } from "@/types";

const observatoryThemeVariants = cva(
  "inline-flex gap-2 items-center py-1 px-2 rounded-full bg-accent",
);

type ObservatoryThemeVariantsProps = VariantProps<
  typeof observatoryThemeVariants
>;

type NativeProps = Omit<
  HTMLAttributes<HTMLSpanElement>,
  keyof ObservatoryThemeVariantsProps
>;

interface ObservatoryThemeProps
  extends NativeProps, ObservatoryThemeVariantsProps {
  theme: ThemeTypeEnum;
}

function ObservatoryTheme({
  className,
  theme,
}: Readonly<ObservatoryThemeProps>): ReactElement {
  const t = useTranslations("global.Theme");
  return (
    <span className={cn(observatoryThemeVariants({ className }))}>
      <ThemeBadge theme={theme} />
      <span className="text-2xs font-semibold uppercase">{t(theme)}</span>
    </span>
  );
}

export { ObservatoryTheme, type ObservatoryThemeProps };
